import routerOptions0 from "/Users/ted/workspace/rphq/rphq-redpoint-api-v1/cpx/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}